import { Card } from "@material-ui/core";
import { FormTab, TabbedForm } from "react-admin";
import React, { useEffect, useState } from "react";
import {
  GeneralFeaturedCompetitions,
  GeneralTabFeaturedCompetitions,
} from "./generalTabFeaturedCompetitions";
import { PreviewTabFeatureCompetitions } from "./previewTabFeatureCompetitions";
import dataProvider from "../../../providers/dataProvider";
export enum COMPETITION_TYPE_ENUM {
  FIXED_ODDS = "Fixed Odds",
  DREAMHOME = "Dream Home",
  PRIZE = "Lifestyle Prizes",
}
export const FeaturedCompetitions = () => {
  const [generalCompetitions, setGeneralCompetitions] = useState<
    Array<GeneralFeaturedCompetitions>
  >(Array<GeneralFeaturedCompetitions>());

  const getGeneralFeturedCompetitionsAsync = async () => {
    const competitions = await dataProvider.getGeneralFeaturedCompetitions();
    setGeneralCompetitions(competitions.data.prizes);
  };

  useEffect(() => {
    getGeneralFeturedCompetitionsAsync();
  }, []);
  return (
    <Card
      component="div"
      className="tabCardWrapper creditsTabLayout user-toolbar"
      id="general-tabs-form"
    >
      <TabbedForm className="user-tabs" toolbar={<></>}>
        <FormTab label="General">
          <GeneralTabFeaturedCompetitions
            competitions={generalCompetitions}
            setGeneralCompetitions={setGeneralCompetitions}
          />
        </FormTab>
        <FormTab label="All prizes">
          <PreviewTabFeatureCompetitions
            getGeneralFeturedCompetitions={getGeneralFeturedCompetitionsAsync}
          />
        </FormTab>
      </TabbedForm>
    </Card>
  );
};
